import { createContext, useContext } from 'react';
import { IBrandsDashboardConfig } from '~/src/dash/views/brands-dashboard/BrandsDashboard/common/types';

interface IBrandsDashboardContext {
  cfg: IBrandsDashboardConfig;
}

export const BrandsDashboardContext = createContext({} as IBrandsDashboardContext);
export const useBrandsDashboardStore = (): IBrandsDashboardContext =>
  useContext(BrandsDashboardContext);
